/**
 * Curated library of predefined fields that users can pick from
 * when creating a custom vault. Grouped by origin for the UI.
 */
export const PREDEFINED_FIELD_GROUPS = [
    {
        label: 'General',
        fields: [
            { key: 'serial_number', label: 'Serial Number', type: 'text', placeholder: 'e.g. SN-12345' },
            { key: 'year', label: 'Year', type: 'number', placeholder: 'e.g. 1985' },
            { key: 'color', label: 'Color', type: 'text', placeholder: 'e.g. Red, Blue' },
            { key: 'material', label: 'Material', type: 'text', placeholder: 'e.g. Steel, Leather, Paper' },
            { key: 'weight', label: 'Weight', type: 'text', placeholder: 'e.g. 250g, 1.5kg' },
            { key: 'dimensions', label: 'Dimensions', type: 'text', placeholder: 'e.g. 10x5x2 cm' },
            { key: 'edition', label: 'Edition', type: 'text', placeholder: 'e.g. First Edition, Limited' },
            { key: 'country_of_origin', label: 'Country of Origin', type: 'text', placeholder: 'e.g. Japan, USA' },
            { key: 'manufacturer', label: 'Manufacturer', type: 'text', placeholder: 'e.g. Sony, Nike' },
            { key: 'rarity', label: 'Rarity', type: 'select', options: ['Common', 'Uncommon', 'Rare', 'Very Rare', 'Unique'] },
            { key: 'certification', label: 'Certification / Grading', type: 'text', placeholder: 'e.g. PSA 9, MS-65' },
            { key: 'is_complete', label: 'Complete Set', type: 'boolean' },
            { key: 'reference_url', label: 'Reference URL', type: 'url', placeholder: 'https://...' },
        ],
    },
    {
        label: 'Electronics & Computing',
        fields: [
            { key: 'cpu', label: 'CPU / Processor', type: 'text', placeholder: 'e.g. MOS 6510, Intel 8088' },
            { key: 'memory', label: 'Memory / RAM', type: 'text', placeholder: 'e.g. 64KB, 4MB' },
            { key: 'storage_capacity', label: 'Storage Capacity', type: 'text', placeholder: 'e.g. 1TB, 360KB' },
            { key: 'wattage', label: 'Wattage', type: 'text', placeholder: 'e.g. 80W per channel' },
            { key: 'connectivity', label: 'Connectivity', type: 'text', placeholder: 'e.g. Bluetooth, USB, RCA' },
        ],
    },
    {
        label: 'Optics & Photography',
        fields: [
            { key: 'lens_mount', label: 'Lens Mount', type: 'text', placeholder: 'e.g. Nikon F, Canon FD' },
            { key: 'focal_length', label: 'Focal Length', type: 'text', placeholder: 'e.g. 50mm' },
            { key: 'aperture_range', label: 'Aperture Range', type: 'text', placeholder: 'e.g. f/1.4 - f/16' },
            { key: 'film_format', label: 'Film Format', type: 'select', options: ['35mm', '120', '4x5', '8x10', 'Instant', 'Other'] },
        ],
    },
    {
        label: 'Horology',
        fields: [
            { key: 'movement_type', label: 'Movement Type', type: 'select', options: ['Automatic', 'Manual Wind', 'Quartz', 'Solar', 'Spring Drive', 'Kinetic'] },
            { key: 'case_material', label: 'Case Material', type: 'text', placeholder: 'e.g. Stainless Steel' },
            { key: 'case_diameter', label: 'Case Diameter', type: 'text', placeholder: 'e.g. 40mm' },
            { key: 'water_resistance', label: 'Water Resistance', type: 'text', placeholder: 'e.g. 200m' },
            { key: 'crystal_type', label: 'Crystal Type', type: 'select', options: ['Sapphire', 'Mineral', 'Acrylic/Hesalite', 'Hardlex'] },
        ],
    },
    {
        label: 'Collectibles & Trading',
        fields: [
            { key: 'mint_mark', label: 'Mint Mark', type: 'text', placeholder: 'e.g. D, S, P' },
            { key: 'face_value', label: 'Face Value', type: 'text', placeholder: 'e.g. $0.25, 1 Franc' },
            { key: 'denomination', label: 'Denomination', type: 'text', placeholder: 'e.g. Penny, Quarter, Crown' },
            { key: 'artist', label: 'Artist / Designer', type: 'text', placeholder: 'e.g. John Smith' },
            { key: 'issue_number', label: 'Issue Number', type: 'text', placeholder: 'e.g. #142, Vol. 3' },
            { key: 'print_run', label: 'Print Run', type: 'text', placeholder: 'e.g. 5000 copies' },
        ],
    },
];
/** Flat list of all predefined fields. */
export const PREDEFINED_FIELD_LIBRARY = PREDEFINED_FIELD_GROUPS.flatMap((g) => g.fields);
//# sourceMappingURL=predefinedFields.js.map